import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoaderProps {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const sizeMap = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
};

export const Loader: React.FC<LoaderProps> = ({ size = 'md', className = '' }) => {
    return (
        <Loader2 className={`${sizeMap[size]} animate-spin text-primary-600 ${className}`} />
    );
};
